import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
} from 'react';
import styled from 'styled-components';
import expoHallAPI from '../api/expoHallAPI';
import { Context as UserContext } from '../context/UserContext';
import { Context as AttendantContext } from '../context/AttendantContext';
import { useHistory, useLocation } from 'react-router-dom';
import { CustomNotification } from '../components/globals/NotificationAgreement';
import { setColor } from '../styles/styles';
import { Context as SocketContext } from '../context/SocketContext';
import SiteData from '../config';
import { BackArrow, InformationalIcon } from '../styles/icons';
import ReactMarkdown from 'react-markdown';
import ReactPlayer from 'react-player';
//time logger for event triggers function
import getTimeLogged from '../utils/getTimeLogged';

//Sweetalert library, second attempt at doing alert for video unmute
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

//material UI slider component for video
import Grid from '@material-ui/core/Grid';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';
import Slider from '@material-ui/core/Slider';
import LogoutButton from '../components/globals/LogoutButton';

const AuditoriumPage = ({ className }) => {
  const {
    state,
    state: { user, user: { first_name, screen_name, last_name } = {} } = {},
    setUser,
  } = useContext(UserContext);
  const { state: { attendant = undefined } = {}, setAttendant } = useContext(
    AttendantContext
  );

  const [auditorium, setAuditorium] = useState(undefined);
  const [openNotification, setOpenNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({});
  const [videoIsPlaying, setVideoIsPlaying] = useState(false);
  const [preVideoIsPlaying, setPreVideoIsPlaying] = useState(true);
  const [videoIsMuted, setVideoIsMuted] = useState(true);
  const [videoRefHasMounted, setVideoRefHasMounted] = useState(false);
  const [volume, setVolume] = useState(50);
  const [differenceAfter, setDifferenceAfter] = useState(0);
  const [isPlaybackTriggered, setIsPlaybackTriggered] = useState(false);
  const [DestinationEndpoint, setDestinationEndpoint] = useState('');
  const [isDescriptionOpen, setisDescriptionOpen] = useState(false);
  const [iFrameLink, setIFrameLink] = useState(null);

  const [videoURL, setVideoURL] = useState(
    'https://expohallimages.s3.amazonaws.com/media/trinity/auditorium_videos/Open_House_Parent_Instruction_Slides_2.mp4'
  );
  const [presentationVideoURL, setPresentationVideoURL] = useState('');
  const [isLooped, setIsLooped] = useState(true);
  // react router variables declaration
  const Location = useLocation();
  const history = useHistory();
  const videoRef = useRef();
  const InfromationRef = useRef();

  //const playbackRef = useRef(false);

  const MySwal = withReactContent(Swal);

  useEffect(() => {
    handleAuthCheck();
    if (SiteData.isMultipleAuditorium) {
      setDestinationEndpoint(Location.pathname.split('/')[2]);
    } else setDestinationEndpoint(1);
  }, []);

  useEffect(() => {
    if (auditorium) !auditorium.is_on_demand && getNotification();
  }, [auditorium]);
  
  useEffect(() => {
    if (user) {
      getAuditorium();
      
    }
  }, [user]);

  useEffect( () => {
    if (user && auditorium) {
      handleAuditoriumAttendence();
    }
  }, [user, auditorium]);

  useEffect(() => {
    if (auditorium?.is_on_demand) {
      setPresentationVideoURL(auditorium?.live_event_link);
      handlePlayVideo();
    }
  });
  
  useEffect(() => {
    if (isDescriptionOpen) {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }
  }, [isDescriptionOpen]);

  const handleClickOutside = (event) => {
    if (
      InfromationRef.current &&
      !InfromationRef.current.contains(event.target)
    ) {
      setisDescriptionOpen(false);
    }
  };

  useLayoutEffect(() => {
    setPresentationVideoURL(auditorium?.live_event_link);
  }, [auditorium]);

  useEffect(() => {
    if (auditorium?.chat_url && (screen_name || first_name)) {
      const displayName = (screen_name && screen_name !== 'None') ? screen_name : first_name + ' '+ last_name;
      setIFrameLink(`${auditorium?.chat_url}?username=${displayName}`);
    }
  }, [first_name, screen_name, auditorium]);

  useEffect(() => {
    if (isPlaybackTriggered && !auditorium?.is_on_demand) {
        const now = new Date();
        const TimeNow = Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours(),
          now.getUTCMinutes(),
          now.getUTCSeconds()
        );
        const EventTime = parseFloat(notificationData.milliseconds);
        const seekTime = TimeNow - EventTime;
        try{
          videoRef.current.seekTo(parseInt(Math.floor(seekTime / 1000)));
        }catch (error){
        }
        //videoRef.current.seekTo(parseInt(Math.floor(differenceAfter / 1000)));
    }
  }, [isPlaybackTriggered]);

  const handleAuthCheck = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-user');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendee/profile/');
      if (data) {
        setUser(data);
      }
    } catch (error) {
      handleAuthCheckAttendant();
    }
  };

  const handleAuthCheckAttendant = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendant/profile/');
      if (data) {
        setUser(data);
        setAttendant(data);
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-user');
      localStorage.removeItem('shrm-li-expo-attendant');
      history.push('/login');
      setUser(undefined);
      setAttendant(undefined);
    }
  };

  const getAuditorium = async () => {
    try {
      const { data } = await expoHallAPI.get(
        `/api/auditoriums/${DestinationEndpoint}/`
      );

      setAuditorium(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAuditoriumAttendence = async () => {
    try{
      if (user && auditorium){ 
        await expoHallAPI.post('/api/auditorium_attendee/', {
            auditorium: auditorium.id,
            user: user.id,
          });
      }
    } catch (error){
      console.log(error.message);
    }
    
  };

  const getNotification = async () => {
    try {
      const { data } = await expoHallAPI.get(
        `/api/notifications/auditorium/${DestinationEndpoint}/`
      );

      data.map((eachData) => {
        timeTriggerActions(eachData);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const timeTriggerNow = (data) => {
    const now = new Date();
    const TimeNow = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const EventTime = parseFloat(data.milliseconds);
    //time left for event
    let TimeLeftForEvent = EventTime - TimeNow;
    if (TimeLeftForEvent < 0) {
      TimeLeftForEvent += 86400000; // adds 1 day (runs everyday)
    }

    const eventDay = new Date(EventTime).getUTCDate();
    if (now.getUTCDate() === eventDay) {
      setTimeout(() => {
        auditoriumActions(data);
      }, TimeLeftForEvent);
    }
  };

  const timeTriggerPeriod = (data) => {
    const now = new Date();
    const EventTime = new Date(data.time);
    const EventEndTime = new Date(data.end_time);
    if (
      new Date(now.toUTCString()) > new Date(EventTime.toUTCString()) &&
      new Date(now.toUTCString()) < new Date(EventEndTime.toUTCString())
    ) {
      auditoriumActions(data);
    }
  };

  const timeTriggerActions = (data) => {
    switch (data.notif_type) {
      case 'NOW':
        timeTriggerNow(data);
        break;
      case 'PERIOD':
        timeTriggerPeriod(data);
        break;
      default:
      // code block
    }
  };

  const auditoriumActions = (data) => {
    const now = new Date(new Date().toUTCString());
    const EventTime = new Date(new Date(data.time).toUTCString());
    const EventEndTime = new Date(new Date(data.end_time).toUTCString());

    const differenceAfter = now.getTime() - EventTime.getTime();
    const differenceBefore = EventEndTime.getTime() - now.getTime();
    const minutes = Math.ceil(differenceAfter / 60000);

    setDifferenceAfter(differenceAfter);
    getTimeLogged(data.id.toString());
    switch (data.action) {
      case 'playPreroll':
        setNotificationData(data);
        setOpenNotification(false);
        // setPresentationVideoURL(auditorium?.waiting_video);
        handlePreload();

        break;

      case 'playAudVideo':
        setNotificationData(data);
        setOpenNotification(false);
        if (auditorium) handlePlayVideo();
        setPresentationVideoURL(auditorium?.live_event_link);
        handleAfterStart(differenceAfter);
        break;

      case 'audIsPlaying':
        //setEventisLive(true);
        data.message = data.message.replace('TIME', minutes.toString());
        data.message = data.message.split('. ').join('.\n');
        data.time = '';
        setNotificationData(data);
        setOpenNotification(true);
        handleAfterStart(differenceAfter);
        setTimeout(() => {
          setOpenNotification(false);
        }, 10000);
        break;
      case 'linkNotification':
        setOpenNotification(true);
        data.buttonText = 'Click Here';
        data.time = '';
        setNotificationData(data);
        setTimeout(() => {
          setOpenNotification(false);
        }, 50000);
        break;
      case 'textNotification':
        setOpenNotification(true);
        data.buttonText = '';
        data.time = '';
        setNotificationData(data);
        setTimeout(() => {
          setOpenNotification(false);
        }, 50000);
        break;
      case 'movePages':
        proceedToExpohall();
        break;
    }
  };

  const handlePreload = () => {
    setVideoIsMuted(true);
    setPreVideoIsPlaying(true);
    setVideoIsPlaying(false);
    handleUnmuteAlertPreload();
  };

  const handlePlayVideo = () => {
    setPreVideoIsPlaying(false);
    !auditorium?.is_on_demand && setIsLooped(false);
    setVideoIsPlaying(true);
  };

  const handleAfterStart = (differenceAfter) => {
    setVideoIsPlaying(true);
    setVideoIsMuted(true);
    setIsLooped(false);
    setPreVideoIsPlaying(false);
    setVideoIsPlaying(true);
    //setTimeout(() => {
    //videoRef.current.seekTo(parseInt(Math.floor(differenceAfter / 1000)));
    //setVideoIsPlaying(true);
    //}, 2000);

    handleUnmuteAlert();

    //videoRef.current.seekTo(parseInt(Math.floor(differenceAfter/1000)));
  };
  const proceedToZoomLink = (link) => {
    window.open(link);
  };

  const proceedToExpohall = () => {
    history.push('/');
  };

  const handleUnmuteAlertPreload = () => {
    MySwal.fire({
      title: '<b>The Video Will Start Playing Soon</b>',
      text: 'Enjoy the presentation!',
      //timer: 6000,
      //timerProgressBar: true,
      willClose: () => {
        setVideoIsMuted(false);
      },
    }).then(() => {
      //return something after, not needed for now
    });
  };

  const handleUnmuteAlert = () => {
    MySwal.fire({
      title: '<b>The Video Is Now Playing</b>',
      text: 'Enjoy the presentation!',
      //timer: 6000,
      //timerProgressBar: true,
      onClose: () => {
        setVideoIsMuted(false);
      },
    }).then(() => {
      //return something after, not needed for now
    });
  };

  const handleVolume = (event, newVolume) => {
    setVolume(newVolume);
  };

  // if (
  //   SiteData.auditoriumChatIds[
  //     parseInt(Location.pathname.split('/')[2]) - 1
  //   ] !==
  //     parseInt(Location.pathname.split('/')[2]) + 1 &&
  //   SiteData.isMultipleAuditorium
  // ) {
  //   return history.push('/notfound');
  // }

  return (
    <Container className={className}>
      <LeftContainer isOnDemand={auditorium?.is_on_demand}>
      {attendant ? (
          <NavigationBar>
          <TopGoBack
            onClick={() => {
              proceedToExpohall();
            }}
          >
            <BackArrow />
            <IconContainer>Return to Virtual Conference</IconContainer>
          </TopGoBack>
          <AudDescription>
            <DescriptionButton
              onClick={() => {
                setisDescriptionOpen((prev) => !prev);
              }}
            >
              Description
            </DescriptionButton>
          </AudDescription>
          {isDescriptionOpen && (
            <DescriptionContent
              ref={InfromationRef}
              isDescriptionOpen={isDescriptionOpen}
            >
              {/* <p> */}

              <ReactMarkdown
              linkTarget='_blank'>
                {!!auditorium.description
                  ? auditorium.description
                  : 'No Information Available'}
              </ReactMarkdown>
              {/* </p> */}
            </DescriptionContent>
          )}
          <LogOutContainer
            onClick={() => {
              expoHallAPI.defaults.headers.common['Authorization'] = '';
              history.push('/login');
              localStorage.removeItem('shrm-li-expo-user');
              setUser(undefined);
              setAttendant(undefined);
              localStorage.removeItem('shrm-li-expo-attendant');
            }}
          >
            <LogoutButton>Logout</LogoutButton>
          </LogOutContainer>
        </NavigationBar>
        ) : (
          <NavigationBar>
            <TopGoBack
              onClick={() => {
                proceedToExpohall();
              }}
            >
              <BackArrow />
              <IconContainer>Return to Virtual Conference</IconContainer>
            </TopGoBack>
            <AudDescription>
              <DescriptionButton
                onClick={() => {
                  setisDescriptionOpen((prev) => !prev);
                }}
              >
                Description
              </DescriptionButton>
            </AudDescription>
            {isDescriptionOpen && (
              <DescriptionContent
                ref={InfromationRef}
                isDescriptionOpen={isDescriptionOpen}
              >
                {/* <p> */}

                <ReactMarkdown linkTarget='_blank'>
                  {!!auditorium.description
                    ? auditorium.description
                    : 'No Information Available'}
                </ReactMarkdown>
                {/* </p> */}
              </DescriptionContent>
            )}
            <LogOutContainer
              onClick={() => {
                expoHallAPI.defaults.headers.common['Authorization'] = '';
                history.push('/login');
                localStorage.removeItem('shrm-li-expo-user');
                setUser(undefined);
                setAttendant(undefined);
                localStorage.removeItem('shrm-li-expo-attendant');
              }}
            >
              <LogoutButton>Logout</LogoutButton>
            </LogOutContainer>
          </NavigationBar>
        )}
        <CustomNotification
          onButtonClick={(e) =>
            notificationData.buttonText === 'Click Here'
              ? proceedToZoomLink(notificationData.external_link)
              : proceedToExpohall()
          }
          buttonText={notificationData.buttonText}
          title={notificationData.title}
          description={notificationData.message}
          time={notificationData.time}
          open={openNotification}
          onCloseIconClick={(e) => {
            setOpenNotification(false);
          }}
        />
        <div className="video-container">
          <div className="video-overlay" />
          <ReactPlayer
            ref={videoRef}
            url={!!presentationVideoURL && presentationVideoURL}
            playing={!auditorium?.is_on_demand && videoIsPlaying}
            height="100%"
            width={'100%'}
            volume={volume / 100}
            muted={videoIsMuted}
            controls={auditorium?.is_on_demand}
            onStart={() => {
              console.log(
                `%cTIME VIDEO STARTED: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onPlay={() => {
              console.log(
                `%cTIME VIDEO PLAYED: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onSeek={() => {
              console.log(
                `%cTIME VIDEO SEEKED: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onReady={() => {
              console.log(
                `%cTIME VIDEO READY: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onBuffer={() => {
              console.log(
                `%cTIME VIDEO BUFFER: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onBufferEnd={() => {
              console.log(
                `%cTIME VIDEO BUFFER END: ${new Date(
                  Date.now()
                ).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
              setIsPlaybackTriggered(true);
            }}
            onEnded={() => {
              console.log(
                `%cTIME VIDEO ENDED: ${new Date(Date.now()).toUTCString()}`,
                'color: orange; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            loop={isLooped}
            //bring up issue with controls placement
            //CHANGE BACK TO FALSE
            //controls={true}
            style={{
              display: videoIsPlaying ? 'flex' : 'none',
              left: 0,
              top: 0,
              backgroundColor: 'black',
              overflow: 'hidden',
              zIndex: 0,
            }}
            //override the html video attributes using config object
            //in this case set preload to load video
            config={{
              file: {
                attributes: {
                  preload: 'auto',
                  controlsList: 'nodownload',
                },
              },
            }}
          />
          <ReactPlayer
            /* url={auditorium?.live_event_link} */
            url={auditorium?.waiting_video}
            playing={preVideoIsPlaying}
            height="100%"
            width={'100%'}
            volume={volume / 100}
            muted={videoIsMuted}
            // controls={auditorium?.is_on_demand}
            //controls
            onStart={() => {
              console.log(
                `%cTIME STARTED: ${new Date(Date.now()).toUTCString()}`,
                'color: green; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            onEnded={() => {
              console.log(
                `%cTIME ENDED: ${new Date(Date.now()).toUTCString()}`,
                'color: orange; font-family:monospace; font-size: 20px; font-weight: bold'
              );
            }}
            loop={isLooped}
            //bring up issue with controls placement
            //CHANGE BACK TO FALSE
            //controls={true}
            style={{
              display: videoIsPlaying ? 'none' : 'flex',
              left: 0,
              top: 0,
              backgroundColor: 'black',
              overflow: 'hidden',
              zIndex: 0,
            }}
            //override the html video attributes using config object
            //in this case set preload to load video
            config={{
              file: {
                attributes: {
                  preload: 'auto',
                  controlsList: 'nodownload',
                },
              },
            }}
          />
        </div>
        {!auditorium?.is_on_demand && (
          <div className="volume-container">
            <Grid container spacing={2} justify="center" alignItems="center">
              <Grid item>
                <VolumeDown fontSize="large" />
              </Grid>
              <Grid item xs>
                <Slider
                  value={volume}
                  onChange={handleVolume}
                  aria-labelledby="continuous-slider"
                  valueLabelDisplay="auto"
                />
              </Grid>
              <Grid item>
                <VolumeUp fontSize="large" />
              </Grid>
            </Grid>
          </div>
        )}
      </LeftContainer>
      <RightContainer>
        <ChatTitle>Session Discussion</ChatTitle>
        <iframe src={iFrameLink} />
      </RightContainer>
    </Container>
  );
};

export default styled(AuditoriumPage)``;

const Container = styled.div`
  display: flex;
`;

const LeftContainer = styled.div`
  position: relative;
  flex: 0.76;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .volume-container {
    width: 25%;
    align-self: flex-end;
    margin: 1rem;
  }
  .video-container {
    position: relative;
    height: 80%;
    margin-top: 8rem;
  }
  .video-overlay {
    position: absolute;
    left: 0;
    //height: 7%;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0);
    z-index: ${(props) => (props.isOnDemand ? '-1' : '1')};
  }
`;

const TopGoBack = styled.div`
  position: absolute;
  /* top: 20px; */
  left: 10px;
  display: flex;
  z-index: 200;
  fill: white;
  transition: all 0.2s;
  flex-direction: row;
  align-items: center;
  :hover {
    cursor: pointer;
    svg {
      transform: translateX(-5px);
      transition: all 0.2s;
    }
    transition: all 0.2s;
  }
  svg {
    height: 4rem;
    width: 4rem;
    display: block;
    margin: 0 auto;
    opacity: 1;
    stroke-width: 3px;
    stroke: white;
  }
`;

const IconContainer = styled.div`
  font-size: 2rem;
  opacity: 1;
  margin-left: 1rem;
`;
const LogOutContainer = styled.div`
  font-size: 2rem;
  opacity: 1;
  margin-left: 1rem;
  position: absolute;
  right: 1%;
  top: 5%;
`;

const RightContainer = styled.div`
  position: relative;
  flex: 0.24;
  height: 100%;
  position: fixed;
  width: 24%;
  right: 0;
  background-color: white;
  height: 100%;
  iframe {
    height: 94%;
  }
  h6 {
    margin-bottom: 0;
  }
`;

const ChatTitle = styled.h6`
  padding-top: 5px;
  text-align: center;
  background-color: ${setColor.midnightBlue};
  padding-bottom: 1rem;
`;

const NavigationBar = styled.div`
  position: relative;
`;
const DescriptionContent = styled.div`
  background: white;
  z-index: 5000;
  position: absolute;
  transition: opacity ease 0.3s 3s;
  opacity: ${(props) => (props.isDescriptionOpen ? '1' : '0')};
  right: 13%;
  background-image: none;
  color: black;
  max-width: 700px;
  padding: 2rem;
  border-radius: 6px;
  box-shadow: 0px 0px 4px #423d3d;
  
  p {
    margin-bottom: 20px;
    font-family: 'Roboto', sans-serif;
    text-align: left;
  }
  ul {
    margin-bottom: 20px;
    li {
      margin-left: 30px;
      margin-bottom: 5px;
      font-size: 15px;
    }
  }
  ol {
    margin-bottom: 20px;
    li {
      margin-left: 20px;
      margin-bottom: 5px;
      font-size: 15px;
      p {
        font-size: 15px;
      }
    }
  }
`;

const AudDescription = styled.div`
  position: absolute;
  right: 8vw;
`;

const DescriptionButton = styled.div`
  width: fit-content;
  border-radius: 100rem;

  margin-left: 0;
  font-family: inherit;
  font-size: 1.4rem;
  color: ${setColor.primaryBlue};
  /* box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5); */
  border: solid 2px transparent;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0)
    ),
    linear-gradient(101deg, ${setColor.primaryBlue}, ${setColor.secondaryBlue});
  background-origin: border-box;
  background-clip: content-box, border-box;
  box-shadow: 2px 1000px 1px ${setColor.mainGrey} inset;
  transition: all 0.2s;
  outline: none;
  backface-visibility: hidden;
  /* disable highlight */
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
  padding: 0.5rem 1rem;

  :hover {
    box-shadow: none;
    color: white;
    transform: scale(1.05);
    transition: all 0.4s;

    /* backface-visibility: hidden; */
  }
  svg {
    height: 30px;
    width: 30px;
  }
  h6 {
    margin: 0;
  }
`;
